<container-default-layout>
  <mat-card appearance="outlined" class="tw-self-center">
    <mat-card-title class="tw-flex">
      <ui-svg-icon [name]="iconNames.CheckmarkFrame" [width]="32"></ui-svg-icon>
      {{ title }}</mat-card-title
    >
    <mat-card-content>
      <p class="description">
        {{ description }}
      </p>
      <div class="tw-flex tw-justify-end">
        <ui-action-button
          [action]="buttonAction.Ok"
          [type]="buttonType.Primary"
          (buttonClick)="buttonClick.next()"
        ></ui-action-button>
      </div>
    </mat-card-content>
  </mat-card>
</container-default-layout>
